import React from "react";
import { NavLink } from "react-router-dom";
import "./HobbliInfo.css";

export default function HobbliInfoLayout({ eyebrow = "Hobbli", title, intro, children }) {
  return (
    <main className="hobbli-info-page">
      <section className="hobbli-info-shell">
        <header className="hobbli-info-hero">
          <span className="hobbli-info-eyebrow">{eyebrow}</span>
          <h1>{title}</h1>
          {intro && <p>{intro}</p>}
        </header>

        <nav className="hobbli-info-nav" aria-label="About and support">
          <NavLink end to="/about">About</NavLink>
          <NavLink to="/about/faq">FAQ</NavLink>
          <NavLink to="/about/contact">Contact & Support</NavLink>
          <NavLink to="/about/terms">Terms</NavLink>
          <NavLink to="/about/privacy">Privacy</NavLink>
        </nav>

        <div className="hobbli-info-content">{children}</div>
      </section>
    </main>
  );
}
